import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearCart,
  decreaseQuantity,
  increaseQuantity,
  removeFromCart,
} from "../../redux/features/cartSlice";
import { excerpt, getPercentage } from "../../resources/helper/helper";
import { Link } from "react-router-dom";

export default function Cart() {
  const dispatch = useDispatch();
  const { cart } = useSelector((state) => state.cart);

  const handleClear = () => {
    dispatch(clearCart());
  };

  const handleIncreaseQuantity = (id) => {
    dispatch(increaseQuantity(id));
  };

  const handleDecreaseQuantity = (id) => {
    dispatch(decreaseQuantity(id));
  };

  const handleRemoveFromCart = (id) => {
    dispatch(removeFromCart(id));
  };
  return (
    <div>
      <main className="main">
        <div className="page-header breadcrumb-wrap">
          <div className="container">
            <div className="breadcrumb">
              <a rel="nofollow">
                <i className="fi-rs-home mr-5" />
                Home
              </a>
              <span /> Shop
              <span /> Cart
            </div>
          </div>
        </div>
        <div className="container mb-80 mt-50">
          <div
            className="row"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div className="col-lg-10 mb-40">
              <h1 className="heading-2 mb-10">Your Cart</h1>
              <div className="d-flex justify-content-between">
                {cart && cart?.length > 0 ? (
                  <h6 className="text-body">
                    There are <span className="text-brand">{cart?.length}</span>{" "}
                    products in your cart
                  </h6>
                ) : (
                  <h6 className="text-body">Your cart is empty</h6>
                )}
                <h6 className="text-body">
                  <a onClick={handleClear} className="text-muted">
                    <i className="fi-rs-trash mr-5" />
                    Clear Cart
                  </a>
                </h6>
              </div>
            </div>
          </div>
          <div
            className="row"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div className="col-lg-10">
              <div className="table-responsive shopping-summery">
                <table className="table table-wishlist">
                  <thead>
                    <tr className="main-heading">
                      <th className="custome-checkbox start pl-30"></th>
                      <th scope="col" colSpan={2}>
                        Product
                      </th>
                      <th scope="col">Unit Price</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Subtotal</th>
                      <th scope="col" className="end">
                        Remove
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {cart && cart?.length > 0 ? (
                      cart?.map((item) => (
                        <tr className="pt-30">
                          <td className="custome-checkbox"></td>
                          <td className="image product-thumbnail pt-40">
                            <img src={item?.featured_media} alt="#" />
                          </td>
                          <td className="product-des product-name">
                            <h6 className="mb-5">
                              <a className="product-name mb-10 text-heading">
                                {excerpt(item?.name, 30)}
                              </a>
                            </h6>
                            <div className="product-rate-cover">
                              <div className="product-rate d-inline-block">
                                <div
                                  className="product-rating"
                                  style={{
                                    width: `${getPercentage(
                                      item?.ratings?.averageRating
                                    )}%`,
                                  }}
                                ></div>
                              </div>
                              <span className="font-small ml-5 text-muted">
                                {item?.ratings?.averageRating
                                  ? item?.ratings?.averageRating
                                  : 0}
                              </span>
                            </div>
                          </td>
                          <td className="price" data-title="Price">
                            <h4 className="text-body">
                              Rs.{item?.discount_price}{" "}
                            </h4>
                          </td>
                          <td
                            className="text-center detail-info"
                            data-title="Stock"
                          >
                            <div className="detail-extralink mr-15">
                              <div className="detail-qty border radius">
                                <a
                                  onClick={() =>
                                    handleDecreaseQuantity(item?._id)
                                  }
                                  className="qty-down"
                                >
                                  <i className="fi-rs-angle-small-down" />
                                </a>
                                <span className="qty-val">
                                  {item?.quantity}
                                </span>
                                <a
                                  onClick={() =>
                                    handleIncreaseQuantity(item?._id)
                                  }
                                  className="qty-up"
                                >
                                  <i className="fi-rs-angle-small-up" />
                                </a>
                              </div>
                            </div>
                          </td>
                          <td className="price" data-title="Price">
                            <h4 className="text-brand">
                              Rs.{item?.discount_price * item?.quantity}{" "}
                            </h4>
                          </td>
                          <td
                            className="action text-center"
                            data-title="Remove"
                          >
                            <a
                              onClick={() => handleRemoveFromCart(item?._id)}
                              className="text-body"
                            >
                              <i className="fi-rs-trash" />
                            </a>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr
                        style={{
                          margin: "20px 0px",
                        }}
                      >
                        <td></td>
                        <td>Please add products!!</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="divider-2 mb-30" />
              <div className="cart-action d-flex justify-content-between">
                <Link to={"/"} className="btn">
                  <i className="fi-rs-arrow-left mr-10" />
                  Continue Shopping
                </Link>
                <Link to={"/checkout"} className="btn  mr-10 mb-sm-15">
                  Proceed To CheckOut
                  <i className="fi-rs-sign-out ml-15" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
